/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = { api: vp.Api };
type HookTuple = [
  { details: vp.HubSpotDealDetails },
  (dealID: string) => Promise<vp.HubSpotDealDetailsResponse>,
  (dealID: string) => void,
  () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchHubSpotDealDetails: ApiHook = ({ api }) => {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [dealID, setDealID] = useState('');
  const [details, setDetails] = useState({
    CompanyHubspotID: '',
    CompanyName: '',
    Industry: '',
    Country: '',
    TransactionsPerMonth: '',
    AverageTransactionSize: '',
    AccountLink: '',
    CompanyWebsite: '',
    PlatformUsage: '',
    CompanyPhone: '',
    SocialMediaPage: '',
    DealCountry: '',
  });

  useEffect(() => {
    const loadData = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');
      const { Details } = await api.fetchHubSpotDealData({ DealID: dealID }, source);
      setDataFetchingInfo(false);
      if (Details) setDetails(Details);
    };

    if (dealID) void loadData();

    return () => {
      source.cancel();
    };
  }, [dealID]);

  return [
    { details },
    (_dealID: string) => api.fetchHubSpotDealData({ DealID: _dealID }, source),
    (_dealID: string) => setDealID(_dealID),
    () => {
      setDetails({
        CompanyHubspotID: '',
        CompanyName: '',
        Industry: '',
        Country: '',
        TransactionsPerMonth: '',
        AverageTransactionSize: '',
        AccountLink: '',
        CompanyWebsite: '',
        PlatformUsage: '',
        CompanyPhone: '',
        SocialMediaPage: '',
        DealCountry: '',
      });
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchHubSpotDealDetails);
